export const INTENTS = {
  POSITIVE: "Thumbs up",
  NEGATIVE: "Thumbs down",
  HELP: "Help",
  WELCOME: "Welcome",
}